export default __webpack_public_path__ + "static/media/thainight4.a13c0a9f.jpg";